import firebase from 'firebase/app'
import 'firebase/database'
import 'firebase/storage'
import 'firebase/auth'
import "firebase/performance";
import "firebase/firestore";
import {
  ninja_config,
  ashyaat_config
} from '@/credentials';
// Initialize Firebase

firebase.initializeApp(ninja_config);

var fb2 = firebase.initializeApp(ashyaat_config, "Secondary");

const db2 = fb2.database();
const db = firebase.database();
const store = firebase.firestore();
const auth = firebase.auth();
const storageRef = firebase.storage().ref();
const perf = firebase.performance();
export {
  firebase,
  db2,
  db,
  auth,
  store,
  perf,
  storageRef,
};
